import React from 'react';

import { Box, Stack, Theme, Typography, useMediaQuery } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';

import { HorizontalCard } from './horizontal-card';
import { VerticalCard } from './vertical-card';

// ********************************************************************************
// The diagram component is layout of images

/* === DIAGRAM PROPS ================================================================== */
interface Props {
  title: string;
  items: { alt: string; backgroundImage: { src: string }; description: string }[][];
}

export const Diagram = (props: Props) => {
  /* === STATES ======================================================================= */
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  /* === RENDER ======================================================================= */
  return (
    <Box component="section" position="relative" bgcolor="#F3F2F5">
      <Box width="100%" display="flex" flexDirection="column" p={{ xs: 4, sm: 10 }} alignItems="center" maxWidth={'xl'} mx={'auto'}>
        <Typography variant="h2" color="#272031" fontFamily="Gotham-Bold" textAlign="center" fontSize={30} mb={{ xs: 5, md: 8 }}>
          <RawHtml content={props.title} />
        </Typography>

        <Box
          width="100%"
          display={{ xs: 'grid', md: 'flex' }}
          gridTemplateColumns="1fr"
          flexWrap="wrap"
          flexDirection="row"
          gap={{ xs: 2.5, md: 8 }}
          py={{ xs: 0.5, md: 3 }}
          mx="auto"
          // alignItems="center"
          justifyContent="center"
          height="fit-content"
        >
          {props.items.map((item, index) => {
            /**
             * It's Horizontal layout
             */
            if (item.length > 1) {
              return (
                <Stack key={index} direction={{ xs: 'row', md: 'column' }} justifyContent={{ xs: 'center', md: 'flex-start' }} spacing={{ xs: 2.5, md: 6 }}>
                  {item.map((item) => (isMobile ? <VerticalCard key={item.description} {...item} /> : <HorizontalCard key={item.description} {...item} />))}
                </Stack>
              );
            }

            return isMobile ? <HorizontalCard key={item[0].description} {...item[0]} /> : <VerticalCard key={item[0].description} {...item[0]} />;
          })}
        </Box>
      </Box>
    </Box>
  );
};
